// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"addEditVehicle_wrapper__2rBIx"};